import React from 'react';
import IconButton from './IconButton';

const RowCopyButton = ({ onClick, entity, disabled }) => (
  <IconButton
    basic
    className="aridhia-row-copy-button"
    dataPosition="bottom right"
    compact
    disabled={disabled}
    icon
    iconClassName="primary"
    iconName="copy"
    iconOnly
    messageId={`actions.copy.${entity}.row`}
    onClick={onClick}
  />
);

export default RowCopyButton;
